var _AppendEnumerator_enumerator, _AppendEnumerator_appendedItemsEnumerator, _AppendEnumerator_current;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import EnumeratorBase from "./EnumeratorBase";
import isUndefinedOrNull from '../TypeHelpers/isUndefinedOrNull';
import NullReferenceException from '../Exceptions/NullReferenceException';
export default class AppendEnumerator extends EnumeratorBase {
    constructor(enumerator, appendedItemsEnumerator) {
        super();
        _AppendEnumerator_enumerator.set(this, void 0);
        _AppendEnumerator_appendedItemsEnumerator.set(this, void 0);
        _AppendEnumerator_current.set(this, void 0);
        __classPrivateFieldSet(this, _AppendEnumerator_enumerator, enumerator, "f");
        __classPrivateFieldSet(this, _AppendEnumerator_appendedItemsEnumerator, appendedItemsEnumerator, "f");
    }
    get current() {
        if (isUndefinedOrNull(__classPrivateFieldGet(this, _AppendEnumerator_current, "f"))) {
            throw new NullReferenceException();
        }
        return __classPrivateFieldGet(this, _AppendEnumerator_current, "f");
    }
    moveNext() {
        if (__classPrivateFieldGet(this, _AppendEnumerator_enumerator, "f").moveNext()) {
            __classPrivateFieldSet(this, _AppendEnumerator_current, __classPrivateFieldGet(this, _AppendEnumerator_enumerator, "f").current, "f");
            return true;
        }
        else if (__classPrivateFieldGet(this, _AppendEnumerator_appendedItemsEnumerator, "f").moveNext()) {
            __classPrivateFieldSet(this, _AppendEnumerator_current, __classPrivateFieldGet(this, _AppendEnumerator_appendedItemsEnumerator, "f").current, "f");
            return true;
        }
        else {
            __classPrivateFieldSet(this, _AppendEnumerator_current, undefined, "f");
            return false;
        }
    }
    peek() {
        let value = undefined;
        if (!isUndefinedOrNull(value = __classPrivateFieldGet(this, _AppendEnumerator_enumerator, "f").peek())) {
            return value;
        }
        else if (!isUndefinedOrNull(value = __classPrivateFieldGet(this, _AppendEnumerator_appendedItemsEnumerator, "f").peek())) {
            return value;
        }
        else {
            return value;
        }
    }
    reset() {
        __classPrivateFieldGet(this, _AppendEnumerator_enumerator, "f").reset();
        __classPrivateFieldGet(this, _AppendEnumerator_appendedItemsEnumerator, "f").reset();
    }
}
_AppendEnumerator_enumerator = new WeakMap(), _AppendEnumerator_appendedItemsEnumerator = new WeakMap(), _AppendEnumerator_current = new WeakMap();
